/**
 * Handles the toggling of the accordion state for a single
 * accordion in the accordion element list.
 */

define(
    'customPlugins/atnAccordion',['knockout', 'lodash'],
    function(ko, _) {
        'use strict';
        ko.bindingHandlers.atnAccordion = {

            init: function(element, valueAccessor) {

                var headerElement = element.querySelector('[atn-role="accordion-header"]'),
                    bodyElement = element.querySelector('[atn-role="accordion-body"]'),
                    displayStateObservable = valueAccessor();

                bodyElement.style.display = displayStateObservable.peek()?'block':'none';
                /**
                 * Add click event handler to the accordion header element.
                 */
                headerElement.addEventListener('click', onHeaderClick);

                /**
                 * Add subscription to take action when the accordion display state is changed.
                 * Action includes hide/show of the accordion body
                 */
                displayStateObservable.subscribe(onDisplayStateToggle);

                /**
                 * onclick handler for the click event on the accordion header.
                 */
                function onHeaderClick(event) {
                    if(event.target.attributes && event.target.attributes.getNamedItem('atn-role') &&
                        event.target.attributes.getNamedItem('atn-role').value.match('accordion-header')){
                        displayStateObservable(!displayStateObservable());
                    }

                }

                /**
                 * Subscription handler. Handle what needs to be done when the accordion state is toggled.
                 * @param value
                 */
                function onDisplayStateToggle(value) {
                    if (value) {
                        bodyElement.style.display = 'block';
                    } else {
                        bodyElement.style.display = 'none';
                    }
                }
            }
        };
    });
